export type IntegrationsPublicConfig = Record<string, Record<string, string>>;

export interface StorefrontProduct {
  id: string;
  name: string;
  slug?: string | null;
  price: number;
  compare_at_price?: number | null;
  image_url?: string | null;
  sku?: string | null;
  categories?: string[];
  url?: string;
}

export interface StorefrontCartItem {
  product_id: string;
  variant_id: string;
  product_name: string;
  variant_name?: string | null;
  price: number;
  quantity: number;
  image_url?: string | null;
  sku?: string | null;
}

export interface StorefrontOrder {
  id: string;
  order_number?: string | null;
  total: number;
  currency?: string;
  tax?: number;
  shipping?: number;
  coupon?: string | null;
  items?: StorefrontCartItem[];
  email?: string | null;
}

export interface StorefrontAdapter {
  id: string;
  isConfigured(cfg: Record<string, string>): boolean;
  /** Inject the vendor script once. */
  load(cfg: Record<string, string>): void;
  identify?(user: { email?: string | null; first_name?: string | null; last_name?: string | null; id?: string | null }): void;
  viewedProduct?(product: StorefrontProduct): void;
  addedToCart?(item: StorefrontCartItem, cart: StorefrontCartItem[]): void;
  startedCheckout?(cart: StorefrontCartItem[], total: number): void;
  orderCompleted?(order: StorefrontOrder): void;
  /** SPA route change: re-render vendor widgets. */
  refresh?(): void;
}

export function loadScriptOnce(id: string, src: string, attrs: Record<string, string> = {}): void {
  if (typeof document === 'undefined') return;
  if (document.getElementById(id)) return;
  const s = document.createElement('script');
  s.id = id;
  s.src = src;
  s.async = true;
  for (const [k, v] of Object.entries(attrs)) s.setAttribute(k, v);
  document.head.appendChild(s);
}
